import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Label, Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";

import DetailBloc from "../Blocs/DetailBloc";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";

class TableComponent extends Component {
  dataTableBloc = new DetailBloc();

  source;
  historyTable = "petanew";
  defaultOrder = "position_mapping_id"; // orderBy
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      periodUuid: null,
      inactiveUuid: null,
      chartUuid: null,
      chart2Uuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }

  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );
    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      uuid: this.props.uuid,
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 2,
      work_unit: this.props.filter.work_unit_uuid,
    };
    await this.dataTableBloc.fetchList(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.listChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.listChannel?.unsubscribe();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.filter !== this.props.filter) {
      this.loadData();
    }
  }

  columns = [
    {
      key: "position_mapping_id",
      text: "Jabatan",
      sortable: true,
      cell: (record) => {
        return record.position_mapping_position_name;
      },
    },
    // {
    //   key: "type_name",
    //   text: "Jenis Jabatan",
    //   sortable: false,
    // },
    {
      key: "echelon_name",
      text: "Posisi",
      sortable: true,
    },
    {
      key: "position_mapping_work_unit_name",
      text: "Unit Kerja",
      sortable: true,
    },
    // {
    //   key: "position_mapping_position_grade",
    //   text: "KLS",
    //   className: "text-center",
    //   sortable: false,
    //   cell: (record) => {
    //     return record.position_mapping_position_grade;
    //     // let quota = record.position_mapping_quota ? record.position_mapping_quota : 0
    //     // let count = record.position_mapping_total
    //     // let color = ''
    //     // if (count > quota) {
    //     //     return <label style={{ color: 'red' }}>{record.position_mapping_pns}</label>
    //     // }
    //     // if (count < quota) {
    //     //     return <label style={{ color: 'blue' }}>{record.position_mapping_pns}</label>
    //     // }
    //     // return <label style={{ color: '' }}>{record.position_mapping_pns}</label>
    //   },
    // },

    {
      key: "position_mapping_kp",
      text: "Formasi",
      className: "text-center",
      sortable: false,
      cell: (record) => {
        return record.position_mapping_bp;
        // let quota = record.position_mapping_quota ? record.position_mapping_quota : 0
        // let count = record.position_mapping_total
        // let color = ''
        // if (count > quota) {
        //     return <label style={{ color: 'red' }}>{record.position_mapping_pppk}</label>
        // }
        // if (count < quota) {
        //     return <label style={{ color: 'blue' }}>{record.position_mapping_pppk}</label>
        // }
        // return <label style={{ color: '' }}>{record.position_mapping_pppk}</label>
      },
    },
    {
      key: "position_mapping_bp",
      text: "Terisi",
      className: "text-center",
      sortable: false,
      cell: (record) => {
        return record.position_mapping_kp;
        // let quota = record.position_mapping_quota ? record.position_mapping_quota : 0
        // let count = record.position_mapping_total
        // let color = ''
        // if (count > quota) {
        //     return <label style={{ color: 'red' }}>{record.position_mapping_cpns}</label>
        // }
        // if (count < quota) {
        //     return <label style={{ color: 'blue' }}>{record.position_mapping_cpns}</label>
        // }
        // return <label style={{ color: '' }}>{record.position_mapping_cpns}</label>
      },
    },

    {
      key: "position_mapping_selisih",
      text: "Lowongan",
      className: "text-center",
      sortable: false,
      cell: (record) => {
        let kp = record.position_mapping_kp;
        let bp = record.position_mapping_bp;
        let selisih = bp - kp;
        if (selisih < 0) {
          return <label style={{ color: "red" }}>{selisih}</label>;
        } else if (selisih > 0) {
          return <label style={{ color: "blue" }}>{selisih}</label>;
        } else {
          return selisih;
        }
        // let quota = record.position_mapping_quota
        //   ? record.position_mapping_quota
        //   : 0;
        // let count = record.position_mapping_total;
        // let color = "";
        // if (count > quota) {
        //   return (
        //     <label style={{ color: "red" }}>
        //       {record.position_mapping_total}
        //     </label>
        //   );
        // }
        // if (count < quota) {
        //   return (
        //     <label style={{ color: "blue" }}>
        //       {record.position_mapping_total}
        //     </label>
        //   );
        // }
        // return (
        //   <label style={{ color: "" }}>{record.position_mapping_total}</label>
        // );
      },
    },

    {
      key: "position_mapping_kp",
      text: "Persentase Keterisian",
      className: "text-center",
      sortable: false,
      width: 200,
      cell: (record) => {
        let formasi = parseInt(record.position_mapping_bp || 0); // Formasi
        let terisi  = parseInt(record.position_mapping_kp || 0); // Terisi

        if (formasi === 0) {
          return (
            <label style={{ 
              color: "white", 
              backgroundColor: "#00bcd4", 
              padding: "3px 8px", 
              borderRadius: "3px",
              fontWeight: "500"
            }}>
              tidak ada
            </label>
          );
        }

        if (terisi < 0) {
          terisi = 0;
        }

        let persen = Math.round((terisi / formasi) * 100);

        let persenDisplay = persen > 100 ? 100 : persen;

        let color;
        let bgColor;

        if (persen === 100) {
          // Hijau: Terisi penuh
          color = "white";
          bgColor = "#4caf50"; // green
        } else if (persen === 0) {
          // Merah: Tidak ada yang terisi
          color = "white";
          bgColor = "#f44336"; // red
        } else if (persen < 40) {
          // Kuning: Keterisian sangat rendah
          color = "#333";
          bgColor = "#ffeb3b"; // yellow
        } else if (persen < 60) {
          // Kuning-Orange: Keterisian rendah
          color = "#333";
          bgColor = "#ffc107"; // amber
        } else if (persen < 100) {
          // Orange: Keterisian tinggi tapi belum penuh
          color = "white";
          bgColor = "#ff9800"; // orange
        }

        return (
          <label style={{ 
            color: color,
            backgroundColor: bgColor,
            padding: "3px 10px",
            borderRadius: "3px",
            fontWeight: "500",
            display: "inline-block",
            minWidth: "60px"
          }}>
            {persenDisplay}%
          </label>
        );
      },
    },

    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.position_mapping_id;
        return (
          <Fragment>
            {/* { record.echelon_code > 10 && record.echelon_code < 30 &&  */}
            <Fragment>
              <span>
                <button
                  className={`btn btn-sm ${
                    (() => {
                      const periode = String(this.props.periode);

                      const pYear = parseInt(periode.substring(0, 4), 10);
                      const pMonth = parseInt(periode.substring(4), 10);

                      const now = new Date();
                      const cYear = now.getFullYear();
                      const cMonth = now.getMonth() + 1;

                      const isPast =
                        pYear < cYear || (pYear === cYear && pMonth < cMonth);

                      return isPast ? "btn-primary" : "btn-warning";
                    })()
                  }`}
                  style={{ marginRight: "2px", padding: "2px 5px" }}
                  id={"edit" + thisId}
                  onClick={() => {
                    this.setState({
                      updateUuid: record.position_mapping_uuid,
                      periodUuid: record.position_mapping_period_uuid,
                    });
                  }}
                >
                  {
                    (() => {
                      const periode = String(this.props.periode);

                      const pYear = parseInt(periode.substring(0, 4), 10);
                      const pMonth = parseInt(periode.substring(4), 10);

                      const now = new Date();
                      const cYear = now.getFullYear();
                      const cMonth = now.getMonth() + 1;
                      const isPast =
                        pYear < cYear || (pYear === cYear && pMonth < cMonth);

                      return isPast
                        ? <i className="uil-align-left"></i>
                        : <i className="uil-pen"></i>;
                    })()
                  }

                </button>
                <Tooltip
                  style={{ marginBottom: "2px" }}
                  placement="top"
                  isOpen={this.state["edit" + thisId]}
                  target={"edit" + thisId}
                  toggle={() => {
                    this.setState({
                      ["edit" + thisId]: !this.state["edit" + thisId],
                    });
                  }}
                >
                {
                    (() => {
                      const periode = String(this.props.periode);

                      const pYear = parseInt(periode.substring(0, 4), 10);
                      const pMonth = parseInt(periode.substring(4), 10);

                      const now = new Date();
                      const cYear = now.getFullYear();
                      const cMonth = now.getMonth() + 1;
                      const isPast =
                        pYear < cYear || (pYear === cYear && pMonth < cMonth);

                      return isPast
                        ? 'Detail'
                        : 'Edit Formasi';
                    })()
                  }
                </Tooltip>
              </span>
              {/* <span>
                <button
                  className="btn btn-primary btn-sm"
                  style={{ marginRight: "2px", padding: "2px 5px" }}
                  id={"chart2" + thisId}
                  onClick={() => {
                    this.setState({
                      chart2Uuid: record.position_mapping_work_unit_uuid,
                      periodUuid: record.position_mapping_period_uuid,
                    });
                  }}
                >
                  <i className="uil-game-structure"></i>
                </button>
                <Tooltip
                  style={{ marginBottom: "2px" }}
                  placement="top"
                  isOpen={this.state["chart2" + thisId]}
                  target={"chart2" + thisId}
                  toggle={() => {
                    this.setState({
                      ["chart2" + thisId]: !this.state["chart2" + thisId],
                    });
                  }}
                >
                  Chart & Pegawai
                </Tooltip>
              </span> */}
              {/* <span>
                <button
                  className="btn btn-primary btn-sm"
                  style={{ marginRight: "2px", padding: "2px 5px" }}
                  id={"chart" + thisId}
                  onClick={() => {
                    this.setState({
                      chartUuid: record.position_mapping_work_unit_uuid,
                      periodUuid: record.position_mapping_period_uuid,
                    });
                  }}
                >
                  <i className="uil-game-structure"></i>
                </button>
                <Tooltip
                  style={{ marginBottom: "2px" }}
                  placement="top"
                  isOpen={this.state["chart" + thisId]}
                  target={"chart" + thisId}
                  toggle={() => {
                    this.setState({
                      ["chart" + thisId]: !this.state["chart" + thisId],
                    });
                  }}
                >
                  Chart ABK
                </Tooltip>
              </span> */}
            </Fragment>
            {/* } */}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <Fragment>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        {this.state.chartUuid !== null && (
          // <Redirect to={"/kepegawaian/petajabatan.html?charts&uuid=" + this.state.chartUuid} />
          <Redirect
            to={`/kepegawaian/petajabatan.html?charts&uuid=${this.state.chartUuid}&period=${this.state.periodUuid}`}
          />
        )}
        {this.state.chart2Uuid !== null && (
          // <Redirect to={"/kepegawaian/petajabatan.html?chartsJabatan&uuid="+this.state.chart2Uuid} />
          <Redirect
            to={`/kepegawaian/petajabatan.html?chartsJabatan&uuid=${this.state.chart2Uuid}&period=${this.state.periodUuid}`}
          />
        )}

        {this.state.updateUuid !== null && (
          <Redirect
            to={`/kepegawaian/petajabatan.html?edit&uuid=${this.state.updateUuid}&period=${this.state.periodUuid}&periodedate=${this.props.periode}`}
          />
        )}
      </Fragment>
    );
  }
}

export default TableComponent;